'use client'

import LinkButton from '@/components/link-button'
import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { ROUTES } from '@/constant/routes'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import AuthHeader from '../components/auth-header'
import { useLoginMutation } from './request'
import { loginSchema, type LoginSchemaType } from './schema'

export default function LoginPage() {
  const form = useForm<LoginSchemaType>({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const { isPending: isLoading, mutateAsync } = useLoginMutation()

  async function onSubmit(values: LoginSchemaType) {
    await mutateAsync(values).catch((error) => {
      toast.error(error?.response?.data?.message || 'Invalid login credentials')
    })
  }

  return (
    <section className="pt-[100px] max-sm:px-8 sm:pe-[190px] sm:ps-[100px]">
      <AuthHeader header="Sign In to your account" />

      <p className="mb-[56px] font-medium text-grey-neutral">
        Fill the fields below to login
      </p>

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="mb-10 space-y-5">
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Email Address</FormLabel>
                <FormControl>
                  <Input
                    placeholder="example@revvapay.com"
                    autoCapitalize="none"
                    autoComplete="email"
                    autoCorrect="off"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Password</FormLabel>
                <FormControl>
                  <Input type="password" placeholder="Enter Password" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <div className="!mb-[56px] flex justify-end">
            <LinkButton
              variant="ghost"
              href={ROUTES.AUTH.FORGOTPASSWORD}
              text="Forgot Password?"
            />
          </div>

          <Button type="submit" size="xl" disabled={isLoading} loading={isLoading}>
            Login
          </Button>
        </form>
      </Form>

      {/* <div className="flex justify-center text-grey-neutral">
        <div className="inline-flex items-center space-x-1.5">
          <p className="text-sm font-semibold">Don’t have an account? </p>
          <LinkButton text="Create Account" href="" variant="ghost" />
        </div>
      </div> */}
    </section>
  )
}
